import React, { Component } from "react";
import "./style.scss";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { withRouter } from "react-router-dom";
import Input from "../../elements/input";
import Dropdown from "../../elements/dropdown";
import Heading from "../../elements/heading";
import { gtag } from "../../utils";
import api from "../../utils/api";
import SuperButton from "../../elements/super-button";
// import { appendQuery } from "../../utils/urlHelper";
/**
 * @typedef {Object} NewsLetterCountry
 * @property {string} MapValue
 * @property {string} Key
 * @property {string} Phrase
 */
class NewsletterCTA extends Component {
  constructor(props, context) {
    super(props, context);
    const { fields, submitted, hasError, errorMessage } = this.props;
    const { emailTipText, defaultCountry, emailErrorTipText, countryTipText } = fields;
    this.state = {
      submitted: submitted ? submitted.status : false,
      emailTipText: emailTipText.value || "",
      defaultCountry: defaultCountry.value || "",
      countryVisible: false,
      hasError: hasError || false,
      errorMessage: errorMessage || null,
      email: null,
      emailIsValid: true,
      emailEnteredShowError: false,
      emailWarningMessage: emailErrorTipText.value || "",
      country: null,
      countryShowError: false,
      countryWarningMessage: countryTipText.value || "",
      countries: []
    };
  }
  componentDidMount() {
    let language = this.props.lang;
    if (language.search("-") === -1) {
      api.country
        .list(null, {
          language: language
        })
        .then(
          /**
           * @param {CountryListRes} res
           */
          res => {
            if (res.code === "1") {
              const countries = res.obj.regions.map(e => {
                return {
                  id: e.regionId,
                  value: e.regionName,
                  code: e.regionNo
                };
              });
              this.setState({
                countries: countries
              });
            }
          }
        )
        .catch(() => {});
      this.setState({
        countryVisible: true
      });
    } else {
      // language = language.split("-")[0];
      this.setState({
        countryVisible: false
      });
    }
  }
  onInputChange(evt, isValid) {
    const { fields } = this.props;
    const email = evt.target.value;
    this.setState({
      hasError: false,
      errorMessage: null,
      email: email,
      emailIsValid: isValid,
      emailEnteredShowError: email && !isValid,
      emailWarningMessage: isValid ? null : fields.emailErrorTipText.value
    });
    this.submitting = false;
  }

  onDropdownChange(value) {
    const { fields } = this.props;
    //console.log("country", value);
    this.setState({
      hasError: false,
      errorMessage: null,
      country: value,
      defaultCountry: !value ? fields.countryTipText.value : fields.defaultCountry.value,
      countryShowError: !value
    });
  }
  onPrivacyClick(e) {
    gtag('event', 'Component_info', {
      'component_name': 'NewsletterCTA',
      'page_title': this?.props?.page?.name
    });
    // const { consent } = this.props.fields;
    // if (e.target.nodeName === "A") {
    //   e.target.href = appendQuery(e.target.href, {
    //     itemId: consent ? consent.id: ""
    //   });
    // }
  }
  async onSubmit() {
    if (!this.submitting) {
      let { lang } = this.props.match.params;
      lang = lang.toLowerCase();
      const { fields } = this.props;
      const { consent, subscribedTipText, defaultErrorText, emailErrorTipText, emailEmptyTipText, countryTipText } = fields;
      const { email, emailIsValid, country, countryVisible } = this.state;
      if (email && emailIsValid && (country || !countryVisible)) {
        this.submitting = true;
        const siteRes = await api.site.get({ key: lang });
        const countryId = lang === "en" ? country.id : siteRes.CountryLocal;
        const consentNo = consent ? consent.id : "";
        const headers = {
          language: siteRes.CountryLang,
          organization: siteRes.CountryOrg,
          lang: lang
        };
        const body = {
          isSubscriptionFlag: "1",
          receiver: email,
          contentMap: {},
          email: email,
          countryId: countryId,
          consentCode: consentNo
        };
        //console.log("POST data =>", body);
        //console.log("headers", headers);
        api
          .bind(null, body, {
            headers: headers
          })
          .then(res => {
            this.setState({
              submitted: true
            });
            api.leads.create(null, {
              emailAddress: email,
              country: countryId,
              preferredLanguage: siteRes.CountryleadsLang,
              contractId: res.obj.contractId
            });
            window.location.hash = `${this.props.page.itemId};submitted`;
          })
          .catch(err => {
            switch (err.code) {
              case "CUSTOMER_SUBSCRIPTION_005":
                this.setState({
                  hasError: true,
                  errorMessage: subscribedTipText ? subscribedTipText.value : "The email is already in use"
                });
                break;
              case "CONSENT_EXCEPTION_016":
                this.setState({
                  emailEnteredShowError: true,
                  emailWarningMessage: emailErrorTipText.value
                });
                break;
              default:
                this.setState({
                  hasError: true,
                  errorMessage: defaultErrorText ? defaultErrorText.value : err.msg
                });
                break;
            }
          })
          .catch(err => {
            switch (err.code) {
              case "CUSTOMER_SUBSCRIPTION_005":
                this.setState({
                  hasError: true,
                  errorMessage: subscribedTipText ? subscribedTipText.value : "The email is already in use"
                });
                break;
              case "CONSENT_EXCEPTION_016":
                this.setState({
                  emailEnteredShowError: true,
                  emailWarningMessage: emailErrorTipText.value
                });
                break;
              default:
                this.setState({
                  hasError: true,
                  errorMessage: defaultErrorText ? defaultErrorText.value : err.msg
                });
                break;
            }
          })
          .finally(() => {
            // this.submitting = false;
          });
      } else {
        if (!email) {
          this.setState({
            emailEnteredShowError: true,
            emailWarningMessage: emailEmptyTipText.value
          });
        } else if (!emailIsValid) {
          this.setState({
            emailEnteredShowError: true,
            emailWarningMessage: emailErrorTipText.value
          });
        }
        if (!country && countryVisible) {
          this.setState({
            countryShowError: true,
            countryWarningMessage: countryTipText.value
          });
        }
      }
    }
  }
  newsletterCTA(model) {
    const { fields, rendering } = model;
    const { paddingAboveTop, paddingAboveBottom, gridType, backgroundColor, CtaName, ctatype, colorScheme, iconName, consent, headingBody, headingType, body, mandatoryText } = fields;
    const { emailTipText, emailWarningMessage, emailEnteredShowError, defaultCountry, countries, countryShowError, countryWarningMessage, countryVisible, errorMessage, hasError } = this.state;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "default";
    const newsletterClasses = classNames("newsletter-cta", "padding-top-" + top, "padding-bottom-" + bottom, {
        "grid-story": (gridType && gridType.fields.phrase.value) === "story",
        grid: (gridType && gridType.fields.phrase.value) === "normal"
      }),
      titleClasses = classNames("title"),
      infoClasses = classNames("info"),
      emailClasses = classNames("email"),
      countryClasses = classNames("country"),
      ctaClasses = classNames("cta"),
      privacyClasses = classNames("privacy");

    let backgroundStyle = {};
    if (backgroundColor) {
      backgroundStyle = {
        background: backgroundColor.fields.phrase.value
      };
    }
    if (CtaName) {
      fields.button = {
        ctatype: ctatype,
        colorScheme: colorScheme,
        iconName: iconName,
        link: {
          value: {
            text: CtaName.value
          }
        },
        isShowModal: {
          value: false
        },
        isDisabled: {
          value: consent ? false : true
        },
        callback: () => this.onSubmit()
      };
    }
    const inputProps = {
      label: emailTipText,
      type: "email",
      warningMessage: emailWarningMessage,
      infoMessage: "",
      mandatory: true,
      showError: emailEnteredShowError,
      onChange: (evt, isValid) => this.onInputChange(evt, isValid),
      onFocus: () => {
        this.setState({ emailEnteredShowError: false });
      }
    };
    const dropdownProps = {
      placeholder: defaultCountry,
      options: countries,
      showError: countryShowError,
      warningMessage: countryWarningMessage,
      onChange: value => this.onDropdownChange(value),
      onFocus: () => {
        this.setState({ countryShowError: false });
      }
    };
    return (
      <div className={newsletterClasses} style={backgroundStyle} datasourceid={rendering.dataSource}>
        {headingBody && headingBody.value && (
          <Heading
            {...{
              type: headingType,
              html: headingBody
            }}
            className={titleClasses}
          />
        )}
        {body && body.value && (
          <div className={infoClasses}>
            <RichText tag={"p"} field={body} />
          </div>
        )}
        <div className={emailClasses}>
          <Input {...inputProps} />
        </div>
        {countryVisible && (
          <div className={countryClasses}>
            <Dropdown {...dropdownProps} />
          </div>
        )}
        {ctatype && (
          <div className={ctaClasses}>
            <SuperButton {...fields.button} />
          </div>
        )}
        {errorMessage && hasError && (
          <div className="error-message">
            <RichText tag={"p"} field={{ value: errorMessage }} />
          </div>
        )}
        {mandatoryText && mandatoryText.value && (
          <div className={privacyClasses} onClick={e => this.onPrivacyClick(e)}>
            <RichText tag={"p"} field={mandatoryText} />
          </div>
        )}
      </div>
    );
  }

  newsletterCTASubmitted(model) {
    const { fields, rendering } = model;
    const { paddingAboveTop, paddingAboveBottom, gridType, backgroundColor, successfulTitle, successfulHeading, successfulBody } = fields;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "default";
    const newsletterClasses = classNames(`newsletter-cta submitted`, "padding-top-" + top, "padding-bottom-" + bottom, {
        "grid-story": (gridType && gridType.fields.phrase.value) === "story",
        grid: (gridType && gridType.fields.phrase.value) === "normal"
      }),
      titleClasses = classNames("title"),
      infoClasses = classNames("info");

    let backgroundStyle = {};
    if (backgroundColor) {
      backgroundStyle = {
        backgroundColor: backgroundColor.fields.phrase.value
      };
    }

    return (
      <div className={newsletterClasses} style={backgroundStyle} datasourceid={rendering.dataSource}>
        {successfulTitle && (
          <Heading
            {...{
              type: successfulHeading,
              html: successfulTitle
            }}
            className={titleClasses}
          />
        )}
        {successfulBody && (
          <div className={infoClasses}>
            <RichText tag={"p"} field={successfulBody} />
          </div>
        )}
      </div>
    );
  }

  render() {
    if (!this.props.fields) return null;
    const model = this.props;
    const { fields } = model;
    if (this.state.submitted === true) {
      return this.newsletterCTASubmitted(model);
    } else {
      if ((fields.gridType && fields.gridType.fields.phrase.value) === "story") {
        return <div className={"grid"}>{this.newsletterCTA(model)}</div>;
      } else {
        return this.newsletterCTA(model);
      }
    }
  }
}
export default withRouter(NewsletterCTA);
